import { UserAuthWrapper } from 'redux-auth-wrapper'
import { push } from 'react-router-redux'

import Loading from '../components/Loading'

export const UserIsAuthenticated = UserAuthWrapper({
  authSelector: state => state.auth.user, // how to get the user state
  authenticatingSelector: state => state.auth.isLoading,
  LoadingComponent: Loading,
  redirectQueryParamName: 'next',
  failureRedirectPath: '/join',
  wrapperDisplayName: 'UserIsAuthenticated' // a nice name for this auth check
});

export const UserIsVerified = UserAuthWrapper({
  authSelector: state => state.auth.user,
  authenticatingSelector: state => state.auth.isLoading,
  LoadingComponent: Loading,
  redirectQueryParamName: 'next',
  failureRedirectPath: '/user/emailverification/required',
  predicate: user => (user && user.verified === true),
  allowRedirectBack: false,
  wrapperDisplayName: 'UserIsVerified'
});



// WEBPACK FOOTER //
// ./src/utils/auth.js